const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORE = "sema_utm";

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (!Object.keys(found).length) return;
    if (document.referrer) found.referrer = document.referrer.slice(0, 300);
    found.landing = window.location.pathname;
    localStorage.setItem(STORE, JSON.stringify(found));
  } catch { /* storage unavailable */ }
}

export function getUtm() {
  try {
    const raw = localStorage.getItem(STORE);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearUtm() {
  try { localStorage.removeItem(STORE); } catch { /* ignore */ }
}
